import { render, staticRenderFns } from "./AirSalonBanner.vue?vue&type=template&id=2584ff59&scoped=true&"
import script from "./AirSalonBanner.vue?vue&type=script&lang=js&"
export * from "./AirSalonBanner.vue?vue&type=script&lang=js&"
import style0 from "./AirSalonBanner.vue?vue&type=style&index=0&id=2584ff59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584ff59",
  null
  
)

export default component.exports